<ng-container [formGroup]="jobroleForm">
    <h3
        class="form-header"
        mat-dialog-title
        *ngIf="!data.id"
        i18n="@@79664ebc68c146564da002dd4f4736f441da166f"
        t="79664ebc68c146564da002dd4f4736f441da166f"
        >Add Job Role</h3
    >
    <h3
        class="form-header"
        mat-dialog-title
        *ngIf="data.id"
        i18n="@@657e8827394314f74e77a94a96bd69449baf4b3c"
        t="657e8827394314f74e77a94a96bd69449baf4b3c"
        >Update Job Role</h3
    >

    <div class="grid">
        <tsl-form-field>
            <tsl-label
                i18n="@@20d9489fdbfc121f7c504271b36691515d02f632"
                t="20d9489fdbfc121f7c504271b36691515d02f632"
                >Job Title</tsl-label
            >
            <input
                autocomplete="off"
                tslInput
                required
                fullWidth
                formControlName="jobtitle"
                [tslAutocomplete]="autoJobtitle"
            />
            <tsl-autocomplete #autoJobtitle="tslAutocomplete" (optionSelected)="onSelectJobtitle($event.option)">
                <tsl-option *ngFor="let item of jobtitles" [value]="item.name">{{
                    translate.get(item.name)
                }}</tsl-option>
            </tsl-autocomplete>
            <tsl-error *ngIf="jobtitle.invalid" i18n="@@Required" t="Required">Required</tsl-error>
        </tsl-form-field>

        <tsl-form-field>
            <tsl-label i18n="@@Department" t="Department">Department</tsl-label>
            <input
                autocomplete="off"
                tslInput
                required
                fullWidth
                formControlName="department"
                [tslAutocomplete]="autoDepartment"
            />
            <tsl-autocomplete #autoDepartment="tslAutocomplete" (optionSelected)="onSelectDepartment($event.option)">
                <tsl-option *ngFor="let item of departments" [value]="item.name">{{
                    translate.get(item.name)
                }}</tsl-option>
            </tsl-autocomplete>
            <tsl-error *ngIf="department.invalid" i18n="@@Required" t="Required">Required</tsl-error>
        </tsl-form-field>
    </div>

    <div class="right">
        <button tsl-button color="black" outline size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button
            tsl-button
            color="blue"
            filled
            size="small"
            [disabled]="jobroleForm.invalid"
            (click)="onSave()"
            i18n="@@Save"
            t="Save"
            >Save</button
        >
    </div>
</ng-container>
